import { render, staticRenderFns } from "./ShiftWork.vue?vue&type=template&id=f9ddf168"
import script from "./ShiftWork.vue?vue&type=script&lang=ts"
export * from "./ShiftWork.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports